export enum FollowUpType {
  Fasli,
  Monthly,
  Yearly,
  Weekly,
}

export const ListOfFollowUpType = [
  { label: "هفتگی", value: FollowUpType.Weekly, require: false },
  { label: "ماهیانه", value: FollowUpType.Monthly, require: true },
  { label: "فصلی", value: FollowUpType.Fasli, require: true },
  { label: "سالیانه", value: FollowUpType.Yearly, require: true },
];
